import { ForwardPriceRequest } from '../../../interfaces';
import { isEmptyString } from '../../../helpers/string.utils';
import { isNil } from '@alk/core';

export function validatePadRequest(request: ForwardPriceRequest): null | string {

    if (!Boolean(request)) {
        return '[FwdPriceService#validatePadRequest] stop request';
    }

    if (isNil(request.quantity) || request.quantity <= 0) {
        return '[FwdPriceService#validatePadRequest] quantity not set';
    }

    if (request.quantity <= 0) {
        return '[FwdPriceService#validatePadRequest] zero quantity';
    }

    if (isEmptyString(request.ccyPair)) {
        return '[FwdPriceService#validatePadRequest] ccyPair not set';
    }

    if (isEmptyString(request.date)) {
        return '[FwdPriceService#validatePadRequest] tenor or date not set';
    }

    return null;
}
